<span #tooltip="matTooltip"
  class="c-tooltip"
  [matTooltip]="tooltipValue"
  [matTooltipPosition]="tooltipPosition"
  [ngClass]="{'c-tooltip--underline': hasUnderline}"
>
  <ng-content></ng-content>
</span>
